import { type FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { CoinMarket } from '@/components/CoinMarket/CoinMarket';
import { Ticker } from '@/components/common/Ticker/Ticker';
import { OffersMarket } from '@/components/OffersMarket/OffersMarket';
import { Background } from '@/components/Shop/Background/Background';
import { PromoCodeTab } from '@/components/Shop/PromoCodeTab/PromoCodeTab';
import { Tab } from '@/components/Tabs/Tab';
import { Tabs } from '@/components/Tabs/Tabs';
import { TabsNavigation } from '@/components/Tabs/TabsNavigation';
import { useAppSelector } from '@/redux/store';

import styles from './styles.module.scss';

const Shop: FC = () => {
  const location = useLocation();
  const dailyBonusHasVisit = useAppSelector(
    (state) => state.user.hasDailyBonusVisit,
  );

  const state = location.state as { activeTab: string } | undefined;
  const tabs = [
    {
      id: '1',
      label: 'Offers',
    },
    {
      id: '2',
      label: 'T-Gems',
    },
    {
      id: '3',
      label: 'Promo Codes',
    },
  ];

  useEffect(() => {
    sessionStorage.setItem('arenaShopCheck', 'true');
  }, []);

  return (
    <main className="w-full h-full relative">
      <Background />
      <div className="w-full h-full flex flex-col pt-[calc(var(--tg-safe-area-inset-top,_0px)_+_6.5rem)] isolate">
        <Tabs initActiveTab={state?.activeTab || '1'}>
          <div className="px-4 py-2.5 relative flex gap-2">
            <TabsNavigation
              list={tabs}
              indexWithIndicator={!dailyBonusHasVisit ? '2' : undefined}
              ticker={() => (
                <div className="absolute -top-[4px] right-0 z-[4]">
                  <Ticker
                    variant="gold-small"
                    className="last:[&>span]:hidden"
                    text="new"
                  />
                </div>
              )}
            />
            {/* {language === 'ru' && <BuyStarsButton />} */}
          </div>
          <Tab
            className={classNames(
              'flex overflow-y-auto grow',
              styles['scroll-hidden'],
            )}
            tabId="1"
          >
            <OffersMarket />
          </Tab>
          <Tab
            className={classNames(
              'flex overflow-y-auto grow',
              styles['scroll-hidden'],
            )}
            tabId="2"
          >
            <CoinMarket />
          </Tab>
          <Tab
            className={classNames(
              'overflow-y-auto px-4',
              styles['scroll-hidden'],
            )}
            tabId="3"
          >
            <PromoCodeTab />
          </Tab>
        </Tabs>
      </div>
    </main>
  );
};

export { Shop };
